import React from 'react'
import logo from 'assets/main/logo.png'
import logoOvar from 'assets/main/ovar.png'
import { useStyles } from './logo.css'
import { Grid, GridSpacing } from '@material-ui/core'
import clsx from 'clsx'

interface Props {
    className?: string
    spacing?: GridSpacing
}

const Logo: React.FC<Props> = ({ className, spacing = 2 }) => {
    const classes = useStyles()
    return (
        <div className={clsx(classes.root, className)}>
            <Grid
                container
                spacing={spacing}
                classes={{
                    root: classes.container,
                }}
                alignItems="center"
            >
                <Grid
                    item
                    xs={6}
                    classes={{
                        root: clsx(classes.logoContainer, classes.logoLeft),
                    }}
                >
                    <img src={logo} alt="SuggPro" />
                </Grid>
                <Grid
                    item
                    xs={6}
                    classes={{
                        root: clsx(classes.logoContainer, classes.logoRight),
                    }}
                >
                    <img src={logoOvar} alt="On va au resto" />
                </Grid>
            </Grid>
        </div>
    )
}

export default Logo
